import type { IconProps } from './IconsTypes'

export const AmericanExpressIcon = ({
  width = 43,
  height = 29,
  viewBox = '0 0 43 29',
  color = '#0071CE',
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12036_7635)">
      <rect width="42.2917" height="29" rx="1.76215" fill="white" />
      <path
        d="M38.7537 25.8284L36.8774 23.5858L34.9288 25.8284H31.104H22.8769V15.3888H19.0521L23.8151 3.71187H28.4338L30.0937 7.73306V3.71187H35.867L36.8774 6.72776L37.8877 3.71187H42.2899V1.93326C42.2899 0.850636 41.496 0 40.4857 0H1.80418C0.793837 0 0 0.850636 0 1.93326V27.0657C0 28.1483 0.793837 28.999 1.80418 28.999H40.4857C41.496 28.999 42.2899 28.1483 42.2899 27.0657V25.8284H38.7537Z"
        fill={color}
      />
      <path
        d="M39.2602 24.5916H42.2912L38.322 20.0291L42.2912 15.5439H39.3323L36.8065 18.4825L34.3528 15.5439H31.3218L35.3631 20.1064L31.3218 24.5916H34.2806L36.8065 21.6531L39.2602 24.5916Z"
        fill={color}
      />
      <path
        d="M26.4849 22.5037V21.1117H31.2479V19.0238H26.4849V17.6319H31.3201V15.5439H24.1755V24.5916H31.3201V22.5037H26.4849Z"
        fill={color}
      />
      <path
        d="M40.054 14.2295H42.219V5.10449L38.755 5.18182L36.8786 10.827L34.9301 5.18182H31.3218V14.2295H33.6311V7.88839L35.7961 14.2295H37.8168L40.054 7.88839V14.2295Z"
        fill={color}
      />
      <path
        d="M27.6395 5.18164H24.6807L20.928 14.2293H23.4538L24.1755 12.4507H28.0725L28.7942 14.2293H31.3922L27.6395 5.18164ZM24.9693 10.3628L26.124 7.42423L27.2787 10.3628H24.9693Z"
        fill={color}
      />
      <path
        d="M40.1968 19.7968L42.2896 22.2714V17.3223L40.1968 19.7968Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_12036_7635">
        <rect width="42.2917" height="29" rx="1.76215" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
